import { Injectable } from '@angular/core';
import {
  NavMenuItem,
  NAV_MENU,
  ACCOUNT_SETTINGS_MENU,
  SETTINGS_MENU,
  MOBILE_MENU,
} from '../types/menu';

@Injectable()
export class MenuService {
  getNavMenu(): NavMenuItem[] {
    return NAV_MENU.map((m) => {
      return { ...m };
    });
  }

  getAccountSettingsNavMenu(): NavMenuItem[] {
    return ACCOUNT_SETTINGS_MENU.map((m) => {
      return { ...m };
    });
  }

  // Deprecated still used in mobile
  getSettingsMenu(): NavMenuItem[] {
    return SETTINGS_MENU.map((m) => {
      return { ...m };
    });
  }

  // Deprecated still used in mobile
  getMobileMenu(): NavMenuItem[] {
    return MOBILE_MENU.map((m) => {
      return { ...m };
    });
  }
}
